export default __webpack_public_path__ + "img/cLOjOtdH.196bc7ef.svg";